import Intercom from '@intercom/messenger-js-sdk'
import { use, useEffect } from 'react'

export default function Component({ children, userData }) {
  useEffect(() => {
    fetch('/api/intercomAPI', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ userData })
    })
      .then((res) => res.json())
      .then((data) => {
        Intercom({
          app_id: process.env.NEXT_PUBLIC_INTERCOM_APP_ID,
          intercom_user_jwt: data.token,
          user_id: userData.userId, // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
          name: userData.fullName, // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
          email: userData.email, // IMPORTANT: Replace "user.email" with the variable you use to capture the user's email
          created_at: Math.floor(new Date(userData.createdAt).getTime() / 1000),
          session_duration: 86400000 // 24 hours in milliseconds
        })
      })
  }, [])

  return <div>{children}</div>
}
